import * as React from 'react';
import { cn } from '@/lib/cn';

// Original field label: 12px, secondary text, regular weight, above the control.
const Label = React.forwardRef<HTMLLabelElement, React.LabelHTMLAttributes<HTMLLabelElement>>(({ className, ...props }, ref) => (
  <label ref={ref} className={cn('block text-xs font-normal leading-4 text-muted-foreground', className)} {...props} />
));
Label.displayName = 'Label';

export { Label };
